import React from 'react';
import { Modal, Button, Card, Form, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FiSave } from 'react-icons/fi';
import { IoPeople } from 'react-icons/io5';

const AssignParentModal = ({
  show,
  displayGroups,
  selectedEntitiesForParent,
  onClose,
  onSave,
  onToggleEntity,
  onOpenParentSelector,
  getEntityParentInfo
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onClose} className="side-modal">
      <Modal.Header>
        <Modal.Title>{t('Assign Parent')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxWidth: '410px' }}>
        <h6 className="mb-3">{t('Select Entities')}</h6>
        {displayGroups && displayGroups.length > 0 ? (
          <div>
            {displayGroups.map((entityGroup, idx) => {
              const parentName = getEntityParentInfo(entityGroup.entityName);
              const isSelected = selectedEntitiesForParent.includes(entityGroup.entityName);
              return (
                <Card
                  key={idx}
                  className="mb-2"
                  style={{
                    cursor: 'pointer',
                    border: isSelected ? '2px solid #007bff' : '1px solid #dee2e6'
                  }}
                  onClick={() => onToggleEntity(entityGroup.entityName)}
                >
                  <Card.Body className="p-3">
                    <div className="d-flex align-items-start">
                      <Form.Check
                        type="checkbox"
                        checked={isSelected}
                        readOnly
                        onChange={() => onToggleEntity(entityGroup.entityName)}
                        onClick={(e) => e.stopPropagation()}
                        className="mr-2 mt-1"
                      />
                      <div className="flex-grow-1">
                        <h6 className="mb-1">{entityGroup.entityName}</h6>
                        <small className="text-muted">
                          {parentName ? (
                            <>
                              <strong>{t('Parent')}:</strong> {parentName}
                            </>
                          ) : (
                            t('No parent assigned')
                          )}
                        </small>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              );
            })}
          </div>
        ) : (
          <Alert variant="info">{t('No entities available')}</Alert>
        )}
        <div className="mt-3">
          <Button
            variant="outline-dark"
            onClick={onOpenParentSelector}
            disabled={selectedEntitiesForParent.length === 0}
            block
          >
            <IoPeople className="mr-2" style={{ verticalAlign: 'middle' }} />
            {t('Select Parent Entity')}
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer className="custom-footer">
        <Button variant="outline-secondary" onClick={onClose} className="mr-2">
          {t('Cancel')}
        </Button>
        <Button variant="dark" onClick={onSave}>
          <FiSave className="mr-2" style={{ verticalAlign: 'middle' }} />
          {t('Save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignParentModal;
